'use strict';

var REDIRECT_DELAY_MS = 10000;
var TICK_MS = 1000;

var LegacyRedirectService = /*@ngInject*/ function (
  $interval,
  ReactNavigationService
) {
  var _self = this;
  var countdownInterval = null;
  var pendingRedirect = null;

  _self.ui = {
    active: false,
    secondsRemaining: 0,
    manualOnly: false,
  };

  function clearPending() {
    if (countdownInterval) {
      $interval.cancel(countdownInterval);
      countdownInterval = null;
    }
    pendingRedirect = null;
  }

  function buildRedirectFn(target, params) {
    return function () {
      ReactNavigationService.goToDestination(target, params);
    };
  }

  _self.complete = function () {
    if (!pendingRedirect) {
      return;
    }

    var redirect = pendingRedirect;
    clearPending();
    _self.ui.active = false;
    _self.ui.secondsRemaining = 0;
    _self.ui.manualOnly = false;
    redirect();
  };

  _self.goNow = function () {
    _self.complete();
  };

  _self.start = function (target, params, options) {
    options = options || {};

    if (_self.ui.active) {
      clearPending();
      _self.ui.active = false;
      _self.ui.secondsRemaining = 0;
      _self.ui.manualOnly = false;
    }

    pendingRedirect = buildRedirectFn(target, params);
    _self.ui.active = true;
    _self.ui.manualOnly = options.manualOnly === true;

    if (_self.ui.manualOnly) {
      _self.ui.secondsRemaining = 0;
      return;
    }

    _self.ui.secondsRemaining = Math.ceil(REDIRECT_DELAY_MS / TICK_MS);

    countdownInterval = $interval(function () {
      _self.ui.secondsRemaining -= 1;
      if (_self.ui.secondsRemaining <= 0) {
        _self.complete();
      }
    }, TICK_MS);
  };
};

module.exports = LegacyRedirectService;
